<template>
  <div class="AppDownload">
    <div class="logoDiv">
      <img src="@/assets/logo.png" class="logoImg">
    </div>
    <div class="title">雅致健康</div>
    <div class="btnDiv">
      <img src="@/assets/DownloadBtn.png" class="DownloadBtnImg" @click="appDown">
    </div>
    <div class="content">
         <div class="appIntroduce">应用介绍</div>
<!--         <div class="appList" style="margin-bottom:1.3rem">雅致健康是一款配合雅致盆底肌治疗仪使用的专-->
<!--           业级家用型APP，具有盆底功能评估，标准化治疗方案，专项盆底锻炼，推荐治疗-->
<!--           方案，健康档-->
<!--           案，医学科谱等功能应用介绍</div>-->
<div class="appIntroduceContent">
      <div class="appIntroduceDoc" style="margin-bottom:1.3rem">雅致健康是一款配合雅致盆底肌治疗仪使用的专业级家用型APP，具有盆底功能评估，标准治疗方案，专项盆底锻炼，健康档案，医学科普等功能。</div>

          <div class="appList"><strong>盆底功能评估：</strong>提供盆底功能筛查及评估报告，清晰了解盆底整体的功能情况。</div>
         <div class="appList"><strong>标准治疗方案：</strong>包含盆底保养、盆底功能障碍治疗、性功能障碍治疗，全面解决盆底问题。</div>
<!--         <div class="appList"><strong>推荐治疗方案：</strong>根据评估结果，针对性的推送治-->
<!--           疗方案。</div>-->
         <div class="appList"><strong>专项盆底锻炼：</strong>根据自身当前的盆底功能状态选择适合的方案。</div>
         <div class="appList"><strong>医学科普：</strong>了解女性健康科普知识。</div>
         <div class="appList"><strong>使用指南：</strong>包含产品说明书、使用视频、常见问题、禁忌症，快速了解使用方法及使用禁忌。</div>
         <div class="appList"><strong>健康档案：</strong>记录历史的评估与治疗数据，直观呈现治疗后的数据变化。</div>
    </div>
  </div>
  </div>
</template>

<script>
import {getAppReleaseVersionApi} from "../api/yz.js";
export default {
  name: 'APP',
  data () {
    return {
      downloadUrl:null,
    }
  },
  beforeMount() {

  },
  mounted() {
    this.appDown()
  },
  methods: {
    async  appDown() {
      let u = navigator.userAgent;
      let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //android终端
      let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      // 判断是安卓还是ios
      if(isIOS){
        //某宝'https://apps.apple.com/cn/app/id387682726'
        //yz 'https://apps.apple.com/cn/app/id6447024012'
        this.downloadUrl = 'https://apps.apple.com/cn/app/id6447024012'
      }else if(isAndroid){
        if(this.downloadUrl==null){
          let para={'appNo':'277141011268589'};
          let res = await getAppReleaseVersionApi(para);
          if(res.data&&res.data.downloadUrl){
            this.downloadUrl =res.data.downloadUrl;
          }
          else {
            this.downloadUrl = 'https://dsmm-elechcy.oss-cn-shenzhen.aliyuncs.com/app/apk/prod/elechcy-V1.0.0.0.apk'
          }
        }
      }
      if(this.downloadUrl!=null){
        window.location.href = this.downloadUrl;
      }
    },
  },
}
</script>

<style scoped>
  .AppDownload{
    background: url("../assets/bg.png") no-repeat;
    width: 100%;
    background-size: 100% 100%;
    height: auto
  }


  .logoDiv{
    width: 100%;
    text-align: center;
    padding-top: 3.2rem;
  }

  .logoImg{
    /* width:5.71rem; */
    width: auto;
    height: auto;
  }

  .title{
    font-family: 'Alibaba PuHuiTi 2.0';
    font-size:24px;
    color: #323232;
    text-align: center;
    width: 100%;
    margin-top: 0.94rem;
    font-weight: normal;
  }
  .btnDiv{
    width: 100%;
    text-align: center;
    margin-top: 1.04rem;
  }
  .DownloadBtnImg{
    /* width: 11.79rem; */
    width: auto;
    height: auto;
  }
  .content{
    width: 100%;
    box-sizing: border-box;
   padding:0 0.66rem 2.875rem 0.66rem; 
    margin-top: 1.41rem;
  }
  .appIntroduceContent{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
  .appIntroduce{
    /* text-align: center;
    color: #34322d;
    font-size:0.83rem;
    margin-bottom: 1.17rem;
    font-weight: bold; */

    font-family: 'Alibaba PuHuiTi 2.0';
font-size: 18px;
margin-bottom: 1.17rem;
font-weight: normal;
line-height: normal;
text-align: center;
letter-spacing: 0em;
font-feature-settings: "kern" on;
color: #323232;
  }
  .appIntroduceDoc{
    font-family: 'Alibaba PuHuiTi 2.0';
font-size: 15px;
font-weight: normal;
line-height: normal;
text-align: justify; /* 浏览器可能不支持 */
letter-spacing: 0em;

font-feature-settings: "kern" on;
color: #646464;
width: 280px;
  }
  .appList{
    /* color: #34322d;
    font-size: 0.66rem;
    line-height: 1rem;
    margin-bottom: 0.2rem; */
    font-family: 'Alibaba PuHuiTi 2.0';
font-size: 12px;
font-weight: normal;
line-height: normal;
text-align: justify; /* 浏览器可能不支持 */
letter-spacing: 0em;
font-feature-settings: "kern" on;
color: #646464;
width: 280px;
margin-bottom: 0.5rem;
  }
  .appList strong{
   font-weight: 700;
  }
</style>



// WEBPACK FOOTER //
// src/pages/DownLoadApp.vue